// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 900px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  overflow: hidden !important;
  max-height: unset !important;
}

.content {
  padding: 10px;
  border-radius: 4px;
  overflow: hidden;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
  display: flex !important;
  justify-content: flex-end !important;
  min-height: unset !important;
}

.button-gap { gap: 12px; }

.btn::after { content: '' !important; display: none !important; }

.materials-grid-container {
  height: 450px;
  overflow: auto;
  border: 1px solid #dbdcdd;
  margin-top: 16px;
}

.materials-grid {
  width: 100%;
  border-collapse: collapse;
}

.table-header {
  background-color: #0066b2;
  color: #ffffff;
  position: sticky;
  top: 0;
  text-align: left;
  white-space: nowrap;
}

.table-header td {
  padding: 8px;
  font-weight: bold;
}

.material-row {
  cursor: pointer;
}

.material-row:hover {
  background-color: #f5f5f5;
}

.material-row td {
  padding: 6px 8px;
  border-bottom: 1px solid #e0e0e0;
}

.center {
  text-align: center;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/manage-materials/manage-materials.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,cAAc,SAAS,EAAE;;AAEzB,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":["mat-dialog-content {\n  min-width: 900px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  overflow: hidden !important;\n  max-height: unset !important;\n}\n\n.content {\n  padding: 10px;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n  display: flex !important;\n  justify-content: flex-end !important;\n  min-height: unset !important;\n}\n\n.button-gap { gap: 12px; }\n\n.btn::after { content: '' !important; display: none !important; }\n\n.materials-grid-container {\n  height: 450px;\n  overflow: auto;\n  border: 1px solid #dbdcdd;\n  margin-top: 16px;\n}\n\n.materials-grid {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-header {\n  background-color: #0066b2;\n  color: #ffffff;\n  position: sticky;\n  top: 0;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.table-header td {\n  padding: 8px;\n  font-weight: bold;\n}\n\n.material-row {\n  cursor: pointer;\n}\n\n.material-row:hover {\n  background-color: #f5f5f5;\n}\n\n.material-row td {\n  padding: 6px 8px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.center {\n  text-align: center;\n}\n\n.spinner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
